/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Serializer for validation error detail.
 */
export interface ValidationErrorDetail { 
    /**
     * Kód chyby (např. 'already_in_kindergarten', 'user_in_different_organization')
     */
    code: string;
    /**
     * Lidsky čitelná zpráva o chybě
     */
    message: string;
    /**
     * Pole, ke kterému se chyba vztahuje (pokud existuje)
     */
    field?: string;
}